import { isDOM } from '@app/shared/predicates'

function trackVisit(): void {
  if (!window.analytics) {
    return
  }

  void window.analytics.page(document.title, {
    path: window.location.pathname,
    host: window.location.host,
  })
}

function reloadAppcuesThroughSegment(): void {
  window.onDomLoad(($dom) => {
    if (isDOM($dom[0])) {
      trackVisit()
    }
  })
}

export default function setupAppcuesThroughSegment(): () => void {
  window.eventHub.$on('appcues-through-segment:loaded', trackVisit)

  reloadAppcuesThroughSegment()

  return reloadAppcuesThroughSegment
}
